export const NOTIFICATION = {
  LEVELS: {
    SUCCESS: "success",
    ERROR: "danger",
    WARNING: "warning",
    INFO: "info"
  }
};
